import { render, staticRenderFns } from "./BnBaseUgyfel.vue?vue&type=template&id=e666f290&"
import script from "./BnBaseUgyfel.vue?vue&type=script&lang=js&"
export * from "./BnBaseUgyfel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports